import type { ReactNode } from 'react';

type Props = {
  label: ReactNode;
  errors?: string[];
  children: ReactNode;
};

export const FormField = ({ label, errors, children }: Props) => (
  <div className={`form-group${errors?.length ? ' has-error' : ''}`}>
    <label className="control-label">{label}</label>
    {children}
    {errors?.[0] && <span className="help-block">{errors[0]}</span>}
  </div>
);
